import {initAjaxModale} from "../../core/js/Modal.ts";


document.addEventListener('DOMContentLoaded', function () {
    if (window.Openscop.afficherFormulaireRoleUtilisateur) {
        initAjaxModale("modal-role-user-dans-organisations", {title : 'Modifier les rôles'}, window.Openscop.url_modifier_role_user_dans_organisations)
    }
})
